export class Color {
  private r: number;
  private g: number;
  private b: number;

  constructor(colorValue: number);
  constructor(colorValue: string);
  constructor(r: number, g: number, b: number);
  constructor(arg1: number | string, arg2?: number, arg3?: number) {
    if (typeof arg1 === "number" && arg2 === undefined && arg3 === undefined) {
      this.validateNumericColorValue(arg1);
      this.r = (arg1 >> 16) & 0xff;
      this.g = (arg1 >> 8) & 0xff;
      this.b = arg1 & 0xff;
    } else if (typeof arg1 === "string") {
      const rgb = this.parseStringColorValue(arg1);
      this.r = rgb[0];
      this.g = rgb[1];
      this.b = rgb[2];
    } else if (typeof arg1 === "number" && typeof arg2 === "number" && typeof arg3 === "number") {
      this.validateIndividualColorValues(arg1, arg2, arg3);
      this.r = arg1;
      this.g = arg2;
      this.b = arg3;
    } else {
      throw new Error("Invalid constructor arguments.");
    }
  }

  private validateNumericColorValue(colorValue: number): void {
    if (colorValue < 0 || colorValue > 0xffffff) {
      throw new Error("Invalid color value. Must be a 3-byte integer.");
    }
  }

  private validateIndividualColorValues(r: number, g: number, b: number): void {
    if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
      throw new Error("Invalid color values. Each value must be an integer between 0 and 255.");
    }
  }

  private parseStringColorValue(colorValue: string): [number, number, number] {
    const regex = /^#([0-9a-fA-F]{6})$/;
    const match = colorValue.match(regex);
    if (!match) {
      throw new Error("Invalid color string. Must be in the format '#RRGGBB'.");
    }
    const color = parseInt(match[1], 16);
    return [(color >> 16) & 0xff, (color >> 8) & 0xff, color & 0xff];
  }

  public getRed(): number {
    return this.r;
  }

  public getGreen(): number {
    return this.g;
  }

  public getBlue(): number {
    return this.b;
  }

  public toNumber(): number {
    return ((this.r & 0xff) << 16) + ((this.g & 0xff) << 8) + (this.b & 0xff);
  }

  public toString(): string {
    return `rgb(${this.r}, ${this.g}, ${this.b})`;
  }

  public toHexString(): string {
    return `#${this.toNumber().toString(16).padStart(6, '0')}`;
  }
}
